const chiffres = (numero: string) => numero.replace(/[^\d+]/g, '')

export const whatsappUrl = (numero: string) => `https://wa.me/${chiffres(numero).replace('+', '')}`

export const telUrl = (numero: string) => `tel:${chiffres(numero)}`

export const mapsUrl = (lat: number, lng: number) =>
  `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`

export const mapsEmbedUrl = (lat: number, lng: number) => `https://www.google.com/maps?q=${lat},${lng}&output=embed`

/** Accepte un identifiant YouTube ou n'importe quel lien YouTube (watch, youtu.be, shorts, live, embed). */
export const extraireVideoId = (valeur: string): string => {
  const v = valeur.trim()
  const match = v.match(/(?:v=|youtu\.be\/|\/shorts\/|\/live\/|\/embed\/)([\w-]{11})/)
  return match ? match[1] : v
}
